<template>
  <div class="employer-insurance-scheme">
    <!-- 搜索工具栏 -->
    <div class="toolbar">
      <span class="search-label">自定义检索:</span>
      <el-select v-model="searchType" style="width: 100px; margin-right: 10px">
        <el-option label="按保险公司" :value="1" />
      </el-select>
      <el-select
        v-model="searchForm.insurance_type"
        placeholder="请输入保险公司"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
      >
        <el-option
          v-for="item in companyList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleShowAll">全部</el-button>

      <el-button
        type="success"
        icon="el-icon-plus"
        style="float: right"
        @click="handleAdd"
      >
        添加方案
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      :height="tableHeight"
    >
      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column
        prop="name"
        label="方案名称"
        min-width="180"
        align="center"
      />

      <el-table-column prop="type" label="方案类型" align="center">
        <template>
          公司雇主
        </template>
      </el-table-column>

      <el-table-column
        prop="insurance_company"
        min-width="400"
        label="保险公司"
        align="center"
      />

      <el-table-column
        prop="insurance_type"
        label="保险公司ID"
        align="center"
      />

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-sizes="[10, 15, 20, 50]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />

    <!-- 添加/编辑对话框 -->
    <SchemeEditDialog
      :visible.sync="editDialogVisible"
      :scheme-data="currentScheme"
      :is-edit="isEdit"
      @refresh="loadSchemeList"
    />

    <!-- 查看对话框 -->
    <SchemeViewDialog
      :visible.sync="viewDialogVisible"
      :scheme-data="currentScheme"
    />
  </div>
</template>

<script>
import {
  getEmployerInsuranceCompanies,
  getEmployerProductList
} from "@/api/employer-insurance";
import SchemeEditDialog from "./components/SchemeEditDialog.vue";
import SchemeViewDialog from "./components/SchemeViewDialog.vue";

export default {
  name: "EmployerInsuranceScheme",
  components: {
    SchemeEditDialog,
    SchemeViewDialog
  },
  data() {
    return {
      loading: false,
      tableData: [],
      companyList: [],
      searchType: 1,
      searchForm: {
        insurance_type: null
      },
      pagination: {
        page: 1,
        pageSize: 15,
        total: 0
      },
      editDialogVisible: false,
      viewDialogVisible: false,
      currentScheme: null,
      isEdit: false,
      tableHeight: 400
    };
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener("resize", this.calculateTableHeight);
    this.initData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateTableHeight);
  },
  methods: {
    async initData() {
      await this.loadCompanyList();
      this.loadSchemeList();
    },

    async loadCompanyList() {
      try {
        const res = await getEmployerInsuranceCompanies();
        if (res && res.err_code === 0) {
          this.companyList = res.rows || [];
        }
      } catch (error) {
        console.error("获取保险公司列表失败:", error);
      }
    },

    async loadSchemeList() {
      this.loading = true;
      try {
        const params = {
          group_by: true,
          page: this.pagination.page,
          rows: this.pagination.pageSize,
          ...this.searchForm
        };

        const res = await getEmployerProductList(params);
        if (res && res.err_code === 0) {
          this.tableData = res.rows || [];
          this.pagination.total = res.total || 0;
        } else if (res) {
          this.$message.error(res.err_msg || "获取雇主险方案列表失败");
        }
      } catch (error) {
        console.error("获取雇主险方案列表失败:", error);
        this.$message.error("获取雇主险方案列表失败");
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.pagination.page = 1;
      this.loadSchemeList();
    },

    handleShowAll() {
      this.searchForm = { insurance_type: null };
      this.pagination.page = 1;
      this.loadSchemeList();
    },

    handleAdd() {
      this.currentScheme = null;
      this.isEdit = false;
      this.editDialogVisible = true;
    },

    handleView(row) {
      this.currentScheme = { ...row };
      this.viewDialogVisible = true;
    },

    handleEdit(row) {
      this.currentScheme = { ...row };
      this.isEdit = true;
      this.editDialogVisible = true;
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.page = 1;
      this.loadSchemeList();
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadSchemeList();
    },

    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight;
        const toolbarHeight = 80;
        const paginationHeight = 60;
        const tabsHeaderHeight = 55;
        const padding = 40;

        this.tableHeight =
          windowHeight -
          toolbarHeight -
          paginationHeight -
          tabsHeaderHeight -
          padding;

        if (this.tableHeight < 300) {
          this.tableHeight = 300;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.employer-insurance-scheme {
  padding: 20px;
  height: 100%;

  .toolbar {
    padding: 8px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;

    .search-label {
      margin-right: 10px;
      font-weight: bold;
    }

    .el-button {
      margin-left: 5px;
    }
  }
}
</style>
